import React, { useState } from 'react'
import { debugEnabled, fullUrl, isTouchDevice } from '../util'
import Card from './Card'
import { cardProps } from '../props'
import classNames from 'classnames'
import { useSelector } from 'react-redux'
import styles from './CardHover.module.scss'

const CardHover = (props) => {
  let { error, legal_commander, is_hero, name, set, number, typo, url, identifier } = useSelector((state) => state.cards[props.name] || {})
  if (!legal_commander) legal_commander = is_hero
  if (!url) url = identifier
  const [isHovering, setIsHovering] = useState(false)

  if (error) {
    return (
      <span
        className={classNames(styles.text, {
          [styles.error]: debugEnabled() && error,
          [styles.typo]: debugEnabled() && typo,
          // [styles.hover90]: hover90,
        })}
      >
        {props.children}
      </span>
    )
  }

  if (isTouchDevice()) {
    return (
      <span className={styles.text}>
        <a
          className={classNames({
            [styles.error]: debugEnabled() && error,
            [styles.typo]: debugEnabled() && typo,
          })}
          onClick={() => {
            setIsHovering(!isHovering)
          }}
        >
          {props.children !== props.name ? props.children : name}
        </a>
        <div
          className={classNames(styles.mobilePreview, {
            [styles.visible]: isHovering,
          })}
          onClick={() => {
            setIsHovering(false)
          }}
        >
          <span
            className={classNames(styles.hover, {
              [styles.visible]: isHovering,
            })}
          >
            <Card {...props} />
          </span>
        </div>
      </span>
    )
  }

  return (
    <span className={styles.text} onMouseEnter={() => setIsHovering(true)} onMouseLeave={() => setIsHovering(false)}>
      <a
        className={classNames({
          [styles.error]: debugEnabled() && error,
          [styles.typo]: debugEnabled() && typo,
        })}
        href={fullUrl({ legal_commander, url, tag: props.tag})}
        target='_blank'
        rel='noopener noreferrer'
      >
        {props.children !== props.name ? props.children : props.name || name}
      </a>
      <span
        className={classNames('shadow', styles.hover, {
          [styles.visible]: isHovering,
        })}
      >
        <Card {...props} />
      </span>
    </span>
  )
}

CardHover.propTypes = cardProps

export default CardHover
